import { Link } from 'gatsby';
import { ThemeUIStyleObject } from 'theme-ui';
import { useProductAnalytics } from '~/hooks/utils/customAnalytics';

type Props = {
  productSlug: string | null;
  collectionSlug?: string | null;
  qs?: string;
  children: React.ReactNode;
  productName: string | null;
  locationDetail?: string;
  sx?: ThemeUIStyleObject;
  className?: string;
  activeClassName?: string;
  partiallyActive?: boolean;
};

const ProductLink = ({
  productSlug,
  collectionSlug,
  qs = '',
  children,
  productName,
  locationDetail,
  sx = {},
  ...props
}: Props) => {
  const { trackProductClicked } = useProductAnalytics(productSlug);
  const url = `/${collectionSlug}/${productSlug}/${qs ? `?${qs}/` : ''}`;

  return (
    // @ts-ignore - need to update to react 18 to fix this
    <Link
      to={url}
      onClick={() => trackProductClicked({ locationDetail, collection: collectionSlug })}
      sx={{ ...sx }}
      aria-label={`Shop for ${collectionSlug} ${productName}`}
      {...props}
    >
      {/* @ts-ignore - need to update to react 18 to fix this */}
      {children}
    </Link>
  );
};

export default ProductLink;
